import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogData {
  type: 'reinstall' | 'downgrade';
  devices: { mac: string; currentVersion: string; targetVersion: string }[];
}

@Component({
  selector: 'app-firmware-confirm-dialog',
  templateUrl: './firmware-confirm-dialog.component.html',
  styleUrls: ['./firmware-confirm-dialog.component.scss']
})
export class FirmwareConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FirmwareConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}
}
